import { useState, useEffect } from 'react';
import { EBreakpoints, breakpoints } from 'pureUi/breakpoints';

const getBreakpoint = (width: number): EBreakpoints => {
  if (width >= breakpoints[EBreakpoints.DESKTOP_UP]) return EBreakpoints.DESKTOP_UP;
  if (width >= breakpoints[EBreakpoints.TABLET_UP]) return EBreakpoints.TABLET_UP;
  return EBreakpoints.MOBILE;
};

export const useBreakpoint = (): EBreakpoints => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<EBreakpoints>(() =>
    getBreakpoint(window.innerWidth)
  );

  useEffect(() => {
    const handler = () => setCurrentBreakpoint(getBreakpoint(window.innerWidth));
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return currentBreakpoint;
};
